{
	"ariaToggleAiTopPicksSuggestions": "Toggle AI Top Picks Suggestions",
	"ariaToggleAutoAdvance": "Toggle Auto Advance",
	"ariaToggleGroupSimilarPhotos": "Toggle Group Similar Photos",
	"ariaToggleRejectBlurryPhotos": "Toggle Reject Blurry Photos",
	"ariaToggleRejectExposureIssues": "Toggle Reject Exposure Issues",
	"ariaToggleRejectPoorFaceQuality": "Toggle Reject Poor Face Quality",
	"autoAdvanceToNextPhoto": "Auto Advance to Next Photo",
	"balanced": "Balanced",
	"blurryBalancedDesc": "Moderately blurry photos are flagged while keeping most sharp shots.",
	"blurryLenientDesc": "Only clearly blurry or heavily out-of-focus photos are flagged.",
	"blurryStrictDesc": "Even minor focus issues are considered blurry and flagged.",
	"count": "Count",
	"exact": "Exact",
	"exactDesc": "Nearly identical photos grouped to the same scene.",
	"faceBalancedDesc": "Rejects most photos with eyes closed unless a strong expression is detected.",
	"faceLenientDesc": "Only rejects photos where subjects have eyes closed and show no strong expression.",
	"faceStrictDesc": "Always rejects photos with people whose eyes are closed.",
	"groupSimilarPhotos": "Group Similar Photos",
	"lenient": "Lenient",
	"loose": "Loose",
	"looseDesc": "Noticeably different photos are grouped to the same scene.",
	"rejectBlurryPhotos": "Reject Blurry Photos",
	"rejectExposureIssues": "Reject Exposure Issues",
	"rejectPoorFaceQuality": "Reject Poor Face Quality",
	"sensitivity": "Sensitivity",
	"showTopPicks": "Show Top Picks",
	"similar": "Similar",
	"similarDesc": "Moderately different photos are grouped to the same scene.",
	"sliderCount": "Count",
	"smartCullingSettings": "Smart Culling Settings",
	"smartCullingSettingsDesc": "Fine-tune your smart culling criteria instantly.",
	"sortByScore": "Sort photos in groups by score",
	"strict": "Strict",
	"topPicksDescription": "Auto-select photos using focus, face, and exposure scores. Best for shoots where creative choices are less important than technical quality, while still leaving the final selection to you."
}
